import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import { CreateAuthentication } from 'components/status-checks/create/CreateAuthentication'
import { CreateStatusCheck } from 'components/status-checks/create/CreateStatusCheck'
import { EditAuthentication } from 'components/status-checks/edit/EditAuthentication'
import { EditStatusCheck } from 'components/status-checks/edit/EditStatusCheck'
import { getStatusChecksUrls } from 'components/status-checks/status-checks-urls-utils'
import { StatusChecksIndexRoutesWrapper } from 'components/status-checks/StatusChecksIndexRoutesWrapper'
import { StatusChecksPage } from 'components/status-checks/StatusChecksPage'
import { TrackedGremlinRouteElement } from 'components/TrackedGremlinRouteElement'
import { useTranslation } from 'hooks/use-translation'

const StatusChecksIndex: React.FC = () => {
  const statusChecksUrls = getStatusChecksUrls()
  const { trans } = useTranslation()

  return (
    <Routes>
      <Route element={<StatusChecksIndexRoutesWrapper />}>
        <Route
          element={
            <TrackedGremlinRouteElement
              loggedIn
              component={<StatusChecksPage />}
              name={trans('status_checks.label.plural')}
            />
          }
          path={':tab/*'}
        />
        <Route path="edit/*">
          <Route
            element={<Navigate replace to={statusChecksUrls.list()} />}
            path="*"
          />
          <Route path="authentication/*">
            <Route
              element={
                <Navigate replace to={statusChecksUrls.authentication()} />
              }
              path="*"
            />
            <Route
              element={
                <TrackedGremlinRouteElement
                  loggedIn
                  component={<EditAuthentication />}
                  name="Edit Authentication"
                />
              }
              path=":integrationName/:observabilityToolType/:domain?"
            />
          </Route>
          <Route
            element={
              <TrackedGremlinRouteElement
                loggedIn
                component={<EditStatusCheck />}
                name={trans('status_checks.edit')}
              />
            }
            path=":statusCheckId"
          />
        </Route>
        <Route path={'new/*'}>
          <Route
            index
            element={
              <TrackedGremlinRouteElement
                loggedIn
                component={<CreateStatusCheck />}
                name={trans('status_checks.create')}
              />
            }
          />
          <Route
            element={
              <TrackedGremlinRouteElement
                loggedIn
                component={<CreateAuthentication />}
                name={trans('status_checks.create')}
              />
            }
            path="authentication"
          />
        </Route>
        {/* any url paths that don't match our routes above redirect to the list */}
        <Route element={<Navigate to={statusChecksUrls.list()} />} path="*" />
      </Route>
    </Routes>
  )
}

// this needs to be a default export because it is a chunk loaded by webpack
export default StatusChecksIndex
